export default [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "site" */ '@/layouts/Site.vue'),
    children: [
      {
        path: '',
        name: 'Homepage',
        component: () => import(/* webpackChunkName: "site" */ '@/views/site/Homepage.vue')
      },
      {
        path: 'products/portal',
        name: 'ProductPortal',
        component: () => import(/* webpackChunkName: "site" */ '@/views/site/products/ProductPortal.vue')
      },
      {
        path: 'products/radar',
        name: 'ProductRadar',
        component: () => import(/* webpackChunkName: "site" */ '@/views/site/products/ProductRadar.vue')
      },
      {
        path: 'pricing',
        name: 'Pricing',
        component: () => import(/* webpackChunkName: "site" */ '@/views/site/Pricing'),
      },
      {
        path: 'contact',
        name: 'Contact',
        component: () => import(/* webpackChunkName: "site" */ '@/views/site/Contact'),
      },
      {
        path: 'reseller',
        name: 'Reseller',
        component: () => import(/* webpackChunkName: "site" */ '@/views/site/Reseller'),
      },
      {
        path: 'terms-of-service',
        name: 'TermsOfService',
        component: () => import(/* webpackChunkName: "site" */ '@/views/site/TermsOfService')
      },
      {
        path: 'privacy-policy',
        name: 'PrivacyPolicy',
        component: () => import(/* webpackChunkName: "site" */ '@/views/site/PrivacyPolicy')
      }
    ]
  }
]